import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

var mergeFunctionTrigger = function mergeFunctionTrigger(fn, field) {
  var internalTriggers = [];
  var internalWhen = fn(field);

  if (Array.isArray(internalWhen)) {
    internalTriggers = _toConsumableArray(internalWhen);
  } else {
    internalTriggers.push(internalWhen);
  }

  return internalTriggers;
};

var getConditionTriggers = function getConditionTriggers(condition, field) {
  var triggers = [];

  if (Array.isArray(condition)) {
    return condition.reduce(function (acc, item) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(getConditionTriggers(item, field)));
    }, []);
  }

  var when = condition.when,
      rest = _objectWithoutProperties(condition, ["when"]);

  var nestedKeys = ['and', 'or', 'sequence'];

  if (typeof when === 'string') {
    triggers = [].concat(_toConsumableArray(triggers), [when]);
  }

  if (typeof when === 'function') {
    triggers = [].concat(_toConsumableArray(triggers), _toConsumableArray(mergeFunctionTrigger(when, field)));
  }

  if (Array.isArray(when)) {
    when.forEach(function (item) {
      if (typeof item === 'string') {
        triggers = [].concat(_toConsumableArray(triggers), [item]);
      }

      if (typeof item === 'function') {
        triggers = [].concat(_toConsumableArray(triggers), _toConsumableArray(mergeFunctionTrigger(item, field)));
      }
    });
  }

  nestedKeys.forEach(function (key) {
    if (typeof rest[key] !== 'undefined') {
      rest[key].forEach(function (item) {
        triggers = [].concat(_toConsumableArray(triggers), _toConsumableArray(getConditionTriggers(item, field)));
      });
    }
  });
  return Array.from(new Set(triggers));
};

export default getConditionTriggers;